<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative">

    <div class="vx-navbar-wrapper" :class="classObj">

      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">

        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />

        <div class="inputDiv">
          <vs-select autocomplete class="selectExample" v-model="selectedCompany">
            <vs-select-item :key="index" :value="item.client_company_id" :text="item.company_name" v-for="(item,index) in companies" />
          </vs-select>
        </div>

        <vs-spacer />

        <profile-drop-down />

        <vs-button class="p-1 mr-3 ml-3" color="dark" type="border" @click="zoomIn">&nbsp;+&nbsp;</vs-button>
        <vs-button class="p-1 mr-3" color="dark" type="border" @click="zoomOut">&nbsp;-&nbsp;</vs-button>

        <i18n :display-text="false"/>

      </vs-navbar>
    </div>
  </div>
</template>


<script>
import Bookmarks            from "./components/Bookmarks.vue"
import SearchBar            from "./components/SearchBar.vue"
import NotificationDropDown from "./components/NotificationDropDown.vue"
import ProfileDropDown      from "./components/ProfileDropDown.vue"
import vSelect from 'vue-select'
import I18n                 from "./components/I18n.vue"


export default {
  name: "the-navbar-vertical",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  components: {
    Bookmarks,
    SearchBar,
    NotificationDropDown,
    ProfileDropDown,
    'v-select': vSelect,
    I18n,
  },
  data() {
    return {
      companies: [],
      selectedCompany: 0,
      changingEnabled: false,
    }
  },
  computed: {
    navbarColorLocal() {
      return this.$store.state.theme === "dark" && this.navbarColor === "#fff" ? "#10163a" : this.navbarColor
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor() {
      return {'text-white': (this.navbarColor != '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor != '#fff' && this.$store.state.theme !== 'dark')}
    },
    windowWidth() {
      return this.$store.state.windowWidth
    },

    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth == "default")      return "navbar-default"
      else if (this.verticalNavMenuWidth == "reduced") return "navbar-reduced"
      else if (this.verticalNavMenuWidth)              return "navbar-full"
    },
  },
  watch: {
    selectedCompany() {

      if (!this.changingEnabled) return;

      const thisIns = this;

      this.$http.post('/api/v1/selectClient/', {
        client_company_id: thisIns.selectedCompany,
      }).then(function (response) {
        thisIns.$store.dispatch('updateUserData', response.data);
        localStorage.setItem('userData', JSON.stringify(response.data));
        thisIns.$router.push({ name: 'allTasks'});
        location.reload();
      }).catch(function () {
        thisIns.$vs.notify({
          title:'Error',
          text: "Change failed",
          color:'danger',
          iconPack: 'feather',
          icon:'icon-alert-circle'})
      });

    }
  },
  methods: {
    showSidebar() {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
    },
    zoomIn() {
      this.$store.dispatch('zoomIn');
    },
    zoomOut(){
      this.$store.dispatch('zoomOut');
    },
    updateClients() {
      const thisIns = this;
      this.$http.get('/api/v1/clients')
              .then(function (response) {
                thisIns.companies = response.data;
                thisIns.selectedCompany = thisIns.$store.getters.userData.client_company_id;
                thisIns.$nextTick(() => {
                  thisIns.changingEnabled = true;
                });

              })
              .catch(function (error) {
                thisIns.$vs.notify({
                  title:'Error',
                  text: error,
                  color:'danger',
                  iconPack: 'feather',
                  icon:'icon-alert-circle'})
              });
    }
  },
  created() {

    this.updateClients();

  }
}
</script>

